import { Transform, Type } from "class-transformer";
import { IsIn, IsNotEmpty, IsNumber, IsString, ValidateNested, IsArray, ArrayMinSize } from "class-validator";
import { IProductVariation, IPack, PromotionActionType, PromotionItemDiscountStrategy } from "../../interfaces";
import { TypeORMRelationId } from "../utils.dto";

class PromotionActionTargetDTO {
  @IsNotEmpty({ message: 'La valeur est requise' })
  @IsString({ message: 'La valeur est invalide' })
  value: string;
}

/**
 * Ajout de produit
 */
export class PromotionActionAddProductVariationDetailsDTO {
  @IsIn([PromotionActionType.ADD_PRODUCT_VARIATION], { message: 'Le type d\'action est requis' })
  type: PromotionActionType.ADD_PRODUCT_VARIATION;

  @ValidateNested({ message: 'La configuration de l\'action est invalide' })
  @Type(() => AddProductVariationDetailsDTO)
  details: Record<string, any>;
}

class AddProductVariationDetailsDTO {
  @IsNotEmpty({ message: 'La valeur est requise' })
  @Type(() => TypeORMRelationId)
  value: IProductVariation;
}


/**
 * Ajout de pack
 */
export class PromotionActionAddPackDetailsDTO {
  @IsIn([PromotionActionType.ADD_PACK], { message: 'Le type d\'action est requis' })
  type: PromotionActionType.ADD_PACK;

  @ValidateNested({ message: 'La configuration de l\'action est invalide' })
  @Type(() => AddPackDetailsDTO)
  details: Record<string, any>;
}

class AddPackDetailsDTO {
  @IsNotEmpty({ message: 'La valeur est requise' })
  @Type(() => TypeORMRelationId)
  value: IPack;
}


/**
 * Remise de commande
 */
export class PromotionActionOrderDiscountFixedDetailsDTO {
  @IsIn([PromotionActionType.ORDER_DISCOUNT_FIXED], { message: 'Le type d\'action est requis' })
  type: PromotionActionType.ORDER_DISCOUNT_FIXED;

  @ValidateNested({ message: 'La configuration de l\'action est invalide' })
  @Type(() => OrderDiscountFixedDetailsDTO)
  details: Record<string, any>;
}

class OrderDiscountFixedDetailsDTO {
  @IsNotEmpty({ message: 'La valeur est requise' })
  @Transform((value) => Number(value))
  @IsNumber({}, { message: 'La valeur est invalide' })
  value: number;
}


/**
 * Remise de commande en pourcentage
 */
export class PromotionActionOrderDiscountPercentageDetailsDTO {
  @IsIn([PromotionActionType.ORDER_DISCOUNT_PERCENTAGE], { message: 'Le type d\'action est requis' })
  type: PromotionActionType.ORDER_DISCOUNT_PERCENTAGE;

  @ValidateNested({ message: 'La configuration de l\'action est invalide' })
  @Type(() => OrderDiscountPercentageDetailsDTO)
  details: Record<string, any>;
}

class OrderDiscountPercentageDetailsDTO {
  @IsNotEmpty({ message: 'La valeur est requise' })
  @Transform((value) => Number(value))
  @IsNumber({}, { message: 'La valeur est invalide' })
  value: number;
}


/**
 * Remise de commande par produit
 */
export class PromotionActionItemsDiscountFixedDetailsDTO {
  @IsIn([PromotionActionType.ITEMS_DISCOUNT_FIXED], { message: 'Le type d\'action est requis' })
  type: PromotionActionType.ITEMS_DISCOUNT_FIXED;

  @ValidateNested({ message: 'La configuration de l\'action est invalide' })
  @Type(() => ItemsDiscountFixedDetailsDTO)
  details: Record<string, any>;
}

class ItemsDiscountFixedDetailsDTO {
  @IsNotEmpty({ message: 'La valeur est requise' })
  @Transform((value) => Number(value))
  @IsNumber({}, { message: 'La valeur est invalide' })
  value: number;

  @IsNotEmpty({ message: 'La valeur est requise' })
  @IsArray({ message: 'La valeur est invalide' })
  @ArrayMinSize(1, { message: 'Au moins une cible est requise' })
  @ValidateNested({ each: true, message: 'La valeur est invalide' })
  @Type(() => PromotionActionTargetDTO)
  targets: PromotionActionTargetDTO[];

  @IsNotEmpty({ message: 'La valeur est requise' })
  @IsIn(Object.values(PromotionItemDiscountStrategy), { message: 'La valeur est invalide' })
  strategy: PromotionItemDiscountStrategy;
}

export class PromotionActionItemsDiscountPercentageDetailsDTO {
  @IsIn([PromotionActionType.ITEMS_DISCOUNT_PERCENTAGE], { message: 'Le type d\'action est requis' })
  type: PromotionActionType.ITEMS_DISCOUNT_PERCENTAGE;

  @ValidateNested({ message: 'La configuration de l\'action est invalide' })
  @Type(() => ItemsDiscountPercentageDetailsDTO)
  details: Record<string, any>;
}

class ItemsDiscountPercentageDetailsDTO {
  @IsNotEmpty({ message: 'La valeur est requise' })
  @Transform((value) => Number(value))
  @IsNumber({}, { message: 'La valeur est invalide' })
  value: number;

  @IsNotEmpty({ message: 'La valeur est requise' })
  @IsArray({ message: 'La valeur est invalide' })
  @ArrayMinSize(1, { message: 'Au moins une cible est requise' })
  @ValidateNested({ each: true, message: 'La valeur est invalide' })
  @Type(() => PromotionActionTargetDTO)
  targets: PromotionActionTargetDTO[];

  @IsNotEmpty({ message: 'La valeur est requise' })
  @IsIn(Object.values(PromotionItemDiscountStrategy), { message: 'La valeur est invalide' })
  strategy: PromotionItemDiscountStrategy;
}

export class PromotionActionDTO {
  @IsIn(Object.values(PromotionActionType), { message: 'Le type d\'action est requis' })
  type: PromotionActionType;

  @IsNotEmpty({ message: 'L\'identifiant de l\'action est requis' })
  referenceId: string;
}
